import { Download, ExternalLink } from "lucide-react";
import { AppImage } from "@/shared/ui/AppImage";
import {
  formatFormSubmissionFileDisplayName,
  getFormSubmissionFilePublicUrl,
  resolveFormSubmissionFileFieldKey,
} from "../utils/form-submission-file-url";

const imageExt = /\.(jpe?g|png|gif|webp|bmp|svg)$/i;

type FormSubmissionFileAnswerProps = {
  fieldType: string;
  value: unknown;
  fileKey: string | null;
};

export function FormSubmissionFileAnswer({
  fieldType,
  value,
  fileKey,
}: FormSubmissionFileAnswerProps) {
  const key = resolveFormSubmissionFileFieldKey(fieldType, value, fileKey);
  if (!key) {
    return <p className="mt-2 text-muted-foreground text-sm">ບໍ່ມີໄຟລ໌</p>;
  }

  const href = getFormSubmissionFilePublicUrl(key);
  const label = formatFormSubmissionFileDisplayName(value, key);
  const showImage = imageExt.test(label) || imageExt.test(key);

  return (
    <div className="mt-2 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 font-medium text-primary text-sm underline underline-offset-2"
        >
          {label}
          <ExternalLink className="h-3.5 w-3.5 shrink-0" aria-hidden />
        </a>
        <a
          href={href}
          download={label}
          className="inline-flex h-8 items-center gap-1.5 rounded-md border border-input bg-background px-2.5 font-medium text-xs shadow-sm hover:bg-accent"
        >
          <Download className="h-3.5 w-3.5 shrink-0" aria-hidden />
          ດາວໂຫຼດ
        </a>
      </div>
      {showImage ? (
        <div className="relative max-w-md overflow-hidden rounded-md border bg-muted">
          <AppImage
            src={key}
            alt={label}
            fit="contain"
            className="max-h-72 w-full"
          />
        </div>
      ) : null}
    </div>
  );
}
